import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { exchangeSession } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing (StrictMode)
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      // Get session_id from URL fragment
      const hash = location.hash;
      const sessionIdMatch = hash.match(/session_id=([^&]+)/);
      
      if (sessionIdMatch) {
        const sessionId = sessionIdMatch[1];
        
        // Exchange session_id for user data
        const user = await exchangeSession(sessionId);
        
        // Clean URL and redirect to main page
        if (user) {
          navigate('/startups', { replace: true, state: { user } });
        } else {
          navigate('/startups', { replace: true });
        }
      } else {
        // No session_id, redirect to startups
        navigate('/startups', { replace: true });
      }
    };

    processAuth();
  }, [location, exchangeSession, navigate]);

  // Silent processing - no loading UI
  return null;
};

export default AuthCallback;
